import { jsonClient } from "../../shared/libs/jsonClient"

/** viewer/editor データ削除 */
export const callDeleteChapterRawData = async (
  chapterId: number,
): Promise<void> => {
  try {
    await jsonClient.request({
      url: `/api/novel/data?chapter_id=${chapterId}`,
      method: "DELETE",
    })
  } catch (error) {
    throw new Error(error)
  }
}
